/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';

/**
 * 
 * @export
 * @interface UploadedFileDto
 */
export interface UploadedFileDto {
    /**
     * Unique identifier for the uploaded file
     * @type {string}
     * @memberof UploadedFileDto
     */
    id: string;
    /**
     * Unique filename stored on disk (UUID-based)
     * @type {string}
     * @memberof UploadedFileDto
     */
    filename: string;
    /**
     * Original filename provided by the user
     * @type {string}
     * @memberof UploadedFileDto
     */
    originalFilename: string;
    /**
     * File size in bytes
     * @type {number}
     * @memberof UploadedFileDto
     */
    size: number;
    /**
     * MIME type (e.g., application/pdf, image/jpeg)
     * @type {string}
     * @memberof UploadedFileDto
     */
    mimeType: string;
    /**
     * Organization context (null for global forms)
     * @type {string}
     * @memberof UploadedFileDto
     */
    organizationId?: string | null;
    /**
     * The application form this file belongs to (null for temporary uploads)
     * @type {string}
     * @memberof UploadedFileDto
     */
    applicationFormId?: string | null;
    /**
     * Reference key of the form element (e.g., grundrechte_folgenabschaetzung)
     * @type {string}
     * @memberof UploadedFileDto
     */
    formElementReference: string;
    /**
     * Timestamp when the file was uploaded
     * @type {Date}
     * @memberof UploadedFileDto
     */
    uploadedAt: Date;
    /**
     * User who uploaded the file
     * @type {UserDto}
     * @memberof UploadedFileDto
     */
    uploadedBy?: UserDto | null;
}

/**
 * Check if a given object implements the UploadedFileDto interface.
 */
export function instanceOfUploadedFileDto(value: object): value is UploadedFileDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('originalFilename' in value) || value['originalFilename'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('formElementReference' in value) || value['formElementReference'] === undefined) return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined) return false;
    return true;
}

export function UploadedFileDtoFromJSON(json: any): UploadedFileDto {
    return UploadedFileDtoFromJSONTyped(json, false);
}

export function UploadedFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadedFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'filename': json['filename'],
        'originalFilename': json['originalFilename'],
        'size': json['size'],
        'mimeType': json['mimeType'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'applicationFormId': json['applicationFormId'] == null ? undefined : json['applicationFormId'],
        'formElementReference': json['formElementReference'],
        'uploadedAt': (new Date(json['uploadedAt'])),
        'uploadedBy': json['uploadedBy'] == null ? undefined : UserDtoFromJSON(json['uploadedBy']),
    };
}

export function UploadedFileDtoToJSON(json: any): UploadedFileDto {
    return UploadedFileDtoToJSONTyped(json, false);
}

export function UploadedFileDtoToJSONTyped(value?: UploadedFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'filename': value['filename'],
        'originalFilename': value['originalFilename'],
        'size': value['size'],
        'mimeType': value['mimeType'],
        'organizationId': value['organizationId'],
        'applicationFormId': value['applicationFormId'],
        'formElementReference': value['formElementReference'],
        'uploadedAt': ((value['uploadedAt']).toISOString()),
        'uploadedBy': UserDtoToJSON(value['uploadedBy']),
    };
}

